import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { SpinnerService } from 'src/app/_components/spinner/spinner.service';

/** Dialog data: either a plain message string (legacy usage) or an object that can also
 *  request the English copy used by MDR operations. */
export type ModalSuccessData = string | { message?: string; english?: boolean };

@Component({
  selector: 'app-modal-success',
  templateUrl: './modal-success.component.html',
  styleUrls: ['./modal-success.component.scss'],
  standalone: false
})
export class ModalSuccessComponent implements OnInit, OnDestroy {

  /** Stays false (and the dialog panel hidden) until the global spinner is idle, so the
   *  success box never overlaps a still-running loader. */
  ready = false;
  message?: string;
  title = 'Operazione eseguita con successo';
  closeLabel = 'CHIUDI';
  private spinnerSub?: Subscription;

  constructor(
    public dialogRef: MatDialogRef<ModalSuccessComponent>,
    @Inject(MAT_DIALOG_DATA) data: ModalSuccessData,
    private spinner: SpinnerService) {
    if (typeof data === 'string') {
      this.message = data;
    } else if (data) {
      this.message = data.message;
      if (data.english) {
        this.title = 'Operation completed successfully';
        this.closeLabel = 'CLOSE';
      }
    }
  }

  ngOnInit(): void {
    if (this.spinner.counter === 0) {
      this.reveal();
      return;
    }
    // Keep the panel out of view while other requests are still loading.
    this.dialogRef.addPanelClass('ms-pending');
    this.spinnerSub = this.spinner.spinnerObservable.subscribe(active => {
      if (!active) this.reveal();
    });
  }

  ngOnDestroy(): void {
    this.spinnerSub?.unsubscribe();
  }

  close() {
    this.dialogRef.close();
  }

  private reveal(): void {
    this.ready = true;
    this.dialogRef.removePanelClass('ms-pending');
    this.spinnerSub?.unsubscribe();
  }

}
